import { useState } from 'react';
import { useInterval } from 'react-use';

const useMilliSecondTick = (ms) => {
  const [tick, setTick] = useState(0);
  useInterval(() => { setTick((t) => 1 - t); }, ms);

  return tick;
};

export default { useMilliSecondTick };
